<template>
  <div class="" :class="[sourceCode === 'aisino' ? 'aisino-box' : 'box']">
    <div class="" id="message" :class="[sourceCode === 'aisino' ? 'aisino-anwer-box' : 'anwer-box']">
      <div class="time">{{time}}</div>
      <!-- 左边的聊天 -->
      <div class="anchat-left">
        <img :src="pc_icon_5" class="img-left" />
        <div class="" :class="[sourceCode === 'aisino' ? 'aisino-dialogue-left' : 'dialogue-left']">{{prologue}}</div>
      </div>
      <!--提示五条-->
      <div class="anchat-left">
        <img :src="pc_icon_5" class="img-left" />
        <div class="" :class="[sourceCode === 'aisino' ? 'aisino-dialogue-left' : 'dialogue-left']">
          <div class="newDayi">最新答疑</div>
          <div
              v-for="(itemanwser,indexanwser) in newsSbimtList"
              :key="indexanwser"
              class="dialogue-line"
              @click="getContent(itemanwser)"
            >
              {{indexanwser + 1}} 、
              <span v-html="itemanwser.title"></span>
              <p>{{itemanwser.source == undefined ? '' : '来源：'+ itemanwser.source}}</p>
              <p>{{itemanwser.publish_time == undefined ? '' : '时间：'+ itemanwser.publish_time}}</p>
            </div>
        </div>
      </div>
      <div v-for="(item,index) in sbimtList" :key="index">
        <!--        时间-->
        <div class="time" v-if="item.type === 0" style="margin-top: 20px">{{item.time}}</div>
        <!--      右边的聊天-->
        <div class="anchat-right" v-else-if="item.type === 1">
          <img :src="pc_icon_6" class="img-right" />
          <div class="" :class="[sourceCode === 'aisino' ? 'aisino-dialogue-right' : 'dialogue-right']">{{item.content}}</div>
          <div class="" :class="[sourceCode === 'aisino' ? 'aisino-anchat-search' : 'anchat-search']">
            <div
              :class="item.issearch === true ? 'serch-btn' : 'serch-btns'"
              @click="tosearchTitle(item,index)"
            >搜标题</div>
            <div
              :class="item.issearch === false ? 'serch-btn' : 'serch-btns'"
              @click="tosearchContent(item,index)"
            >搜正文</div>
          </div>
        </div>
        <!--      左边的聊天-->
        <div class="anchat-left" v-if="item.type === 2">
          <img :src="pc_icon_5" class="img-left" />
          <div class="" :class="[sourceCode === 'aisino' ? 'aisino-dialogue-left' : 'dialogue-left']" v-if="item.titledata.length > 0">
            <p>以下问题可能对您有帮助：</p>
            <div
              v-for="(itemanwser,indexanwser) in item.titledata"
              :key="indexanwser"
              class="dialogue-line"
              @click="getContent(itemanwser)"
            >
              {{indexanwser + 1}} 、
              <span v-html="itemanwser.title"></span>
              <p>{{itemanwser.source == undefined ? '' : '来源：'+ itemanwser.source}}</p>
              <p>{{itemanwser.publish_time == undefined ? '' : '时间：'+ itemanwser.publish_time}}</p>
            </div>
            <div v-if="item.titledata.length > 0" class="page-btn">
              <div v-if="item.morename === '没有更多数据'">{{item.morename}}</div>
              <div v-else @click="moreList(item,index)">{{item.morename}}</div>
            </div>
          </div>
          <div class="" :class="[sourceCode === 'aisino' ? 'aisino-dialogue-left' : 'dialogue-left']" v-else>{{unmatch}}</div>
        </div>
        <!--      左边的聊天-->
        <div class="anchat-left" v-if="item.type === 3">
          <img :src="pc_icon_5" class="img-left" />
          <div class="" :class="[sourceCode === 'aisino' ? 'aisino-dialogue-left' : 'dialogue-left']">
            <span v-html="item.content.content_formatted"></span>
            <p
              class="text-font"
            >{{item.content.source == undefined ? '' : '来源：'+ item.content.source}}</p>
            <p
              class="text-font"
            >{{item.content.publish_time == undefined ? '' : '时间：'+ item.content.publish_time}}</p>
            <div>温馨提示：{{prompt}}</div>
            <!--新增收藏-->
            <div class="shoucangBox" v-if="!isCJT">
              <div class="shoucangBoxRight" v-if="item.content.isCollection==0" @click="getSCHandle(item.content.isCollection,item.content.id,index)">
                <img :src="sbwpcSC" alt="">
                <span>收藏</span>
              </div>
              <div  class="shoucangBoxRight"  v-if="item.content.isCollection==1" @click="getSCHandle(item.content.isCollection,item.content.id,index)">
                <img :src="sbwpcYSC" alt="">
                <span>已收藏</span>
              </div>
            </div>
            <div class="resol-box">
              <div
                :class="item.typeid && item.typeid == 2 ? 'unresolved' : 'resolved'"
                @click="getTap(2,index)"
              >未解决</div>
              <div
                :class="item.typeid && item.typeid == 1 ? 'unresolveds' : 'resolveds'"
                @click="getTap(1,index)"
              >已解决</div>
            </div>
          </div>
        </div>
      </div>
      <!--底部用于定位操作-->
      <div id="bottomFixed"></div>
    </div>
    <div class="" :class="[sourceCode === 'aisino' ? 'aisino-send-content' : 'send-content']">
      <el-input
        type="textarea"
        :autosize="{ minRows: 3, maxRows: 20}"
        :placeholder="this.$store.state.userInfo.nickname != undefined  ? '请输入关键词查询，支持标题和正文查询' : '登录之后才能提问问题呦！'"
        v-model="textarea"
        :disabled="this.$store.state.userInfo.nickname != undefined  ? false : true"
      ></el-input>
      <el-button @click="send()" :disabled="textarea === '' ? true : false" :loading="btnloading">发送</el-button>
    </div>
  </div>
</template>
<script>
import pc_icon_5 from "@/assets/pc_icon_5.png";
import pc_icon_6 from "@/assets/pc_icon_6.png";

//liyanze分支增加引入图片眷思量
import sbwpcYSC from "@/assets/sbwpcYSC.png";
import sbwpcSC from "@/assets/sbwpcSC.png";
import { API_DATA } from "@/api/index";
import config from "@/config";
const passportUrl = config[process.env.NODE_ENV].passportUrl;
export default {
  name: "index",
  components: {},
  data() {
    return {
      pc_icon_5,
      pc_icon_6,
      sbwpcYSC,
      sbwpcSC,
      textarea: "", //用户提问的内容
      prologue: "", //刚进页面的提示语
      prompt: "", //回答问题的提示
      unmatch: "", //未匹配到问题的提示
      sbimtList: [], //列表
      page: 1, //分页
      keyWord: undefined, //按正文搜索
      title: undefined, //按标题搜索
      questionId: null, //问题id
      fz: "", //时间
      time: "", //时间
      times: "", //时间
      index: 0, //监听值是否改变 改变调接口 否则不调接口
      btnloading: false, //发送的loading
      sourceCode: "",
      //五条
      newsSbimtList: [],
      //定位
      thatScrollHeight:0,
      thatScrollTop:0,
      //是否为畅捷通
      isCJT:false,
    };
  },
  created(){
    //debugger
  },
  activated() {
    //重置 
    this.sbimtList = [];
    var time = new Date();
    this.fz = time.getMinutes();
    this.sourceCode = this.$route.query.sourceCode;
    console.log(this.$route.query)
    if (parseInt(time.getMinutes()) < parseInt(10)) {
      this.time = time.getHours() + ":0" + time.getMinutes();
    } else {
      this.time = time.getHours() + ":" + time.getMinutes();
    }
    this.getDictionariesAll();
    this.getFiveData();

    //判断是否为 航信通
    let thatQuery = this.$route.query.sourceCode;
    if(thatQuery == 'aisino'){
      this.isCJT = true;
    }else{
      //this.isCJT = false;
    }
    //判断是否为 畅捷通(测试)
    let thatQueryGG_daily = this.$route.query.sourceCode;
    if(thatQueryGG_daily == 'chanjetDefault'){
      this.isCJT = true;
    }else{
      //this.isCJT = false;
    }
    //判断是否为 畅捷通(正式)
    let thatQueryGG = this.$route.query.sourceCode;
    if(thatQueryGG == 'cdsyqy'){
      this.isCJT = true;
    }else{
      //this.isCJT = false;
    }
  },
  methods: {
    changeTitle() {
      console.log(window.location.href);
      console.log(this.sourceCode);
      console.log(this.titleList[this.sourceCode].title);
      // document.title = this.titleList[this.sourceCode].title
    },
    getDictionariesAll() {
      let that = this;
      API_DATA.dictionariesAll().then((res) => {
        //遍历获取提示语
        res.data.map(function (item) {
          if (item.code === "chat_prologue") {
            //刚进入页面的提示语
            that.prologue = item.value;
          } else if (item.code === "chat_prompt") {
            //回答问题的提示
            that.prompt = item.value;
          } else if (item.code === "chat_unmatch") {
            //未匹配到问题的提示
            that.unmatch = item.value;
          } else if (item.code == "chanjet_data") {
            //标题
            that.titleList = JSON.parse(item.value);
          }
        });
      });
    },
    //点击发送
    send() {
      this.sbimtList.push({
        content: this.textarea,
        type: 1,
        searchcontent: this.textarea,
        issearch: true,
      });
      this.keyWord = undefined;
      this.title = this.textarea;
      this.btnloading = true;
      this.getAnswerAll();
    },
    //点击搜索标题
    tosearchTitle(item, index) {
      this.title = item.searchcontent;
      this.keyWord = undefined;
      this.sbimtList[index].issearch = true;
      this.getAnswerAll();
    },
    //点击搜索正文
    tosearchContent(item, index) {
      this.keyWord = item.searchcontent;
      this.title = undefined;
      this.sbimtList[index].issearch = false;
      this.getAnswerAll();
    },
    //点击更多
    moreList(item, index) {
      console.log(item);
      item.page++;
      this.getAnswerAlls(index, item.page);
    },
    //点击更多
    getAnswerAlls(index, page) {
      API_DATA.getAnswer(this.keyWord, this.title, page).then((res) => {
        this.questionId = res.data.question.id;
        this.sbimtList[index].titledata = this.sbimtList[
          index
        ].titledata.concat(res.data.data);
        if (page * 10 < res.data.total) {
          this.sbimtList[index].morename = "更多";
        } else {
          this.sbimtList[index].morename = "没有更多数据";
        }
        
        //定位更新
        this.$nextTick(function(){
          let tMessage  = this.$el.querySelector("#message")
          let that = this;
          that.thatScrollHeight = tMessage.scrollHeight
        })
      });
    },
    //获取最新五条答疑数据
    getFiveData(){
      API_DATA.getAnswerFive("",1,5).then((res) => {
        this.btnloading = false;
        this.questionId = res.data.question.id;
        var timemax = Math.abs(new Date().getMinutes() - this.fz);
        var time = new Date();
        if (parseInt(time.getMinutes()) < parseInt(10)) {
          this.times = time.getHours() + ":0" + time.getMinutes();
        } else {
          this.times = time.getHours() + ":" + time.getMinutes();
        }
        if (parseInt(timemax) >= parseInt(5)) {
          this.sbimtList.push({
            type: 0,
            time: this.times,
          });
          this.fz = time.getMinutes();
        }
        if (res.data.total > 10) {
          this.newsSbimtList = res.data.data
        } else {
          this.newsSbimtList = res.data.data
        }

        //搜索定位
        this.$nextTick(function(){
          let tMessage  = this.$el.querySelector("#message")
          let that = this;
          that.thatScrollHeight = tMessage.scrollHeight
        })
        this.textarea = "";
      });
      
    },
    //获取回答文章列表
    getAnswerAll() {
      API_DATA.getAnswer(this.keyWord, this.title, this.page).then((res) => {
        this.btnloading = false;
        this.questionId = res.data.question.id;
        var timemax = Math.abs(new Date().getMinutes() - this.fz);
        var time = new Date();
        if (parseInt(time.getMinutes()) < parseInt(10)) {
          this.times = time.getHours() + ":0" + time.getMinutes();
        } else {
          this.times = time.getHours() + ":" + time.getMinutes();
        }
        if (parseInt(timemax) >= parseInt(5)) {
          this.sbimtList.push({
            type: 0,
            time: this.times,
          });
          this.fz = time.getMinutes();
        }
        if (res.data.total > 10) {
          this.sbimtList.push({
            titledata: res.data.data,
            type: 2,
            page: 1,
            morename: "更多",
          });
        } else {
          this.sbimtList.push({
            titledata: res.data.data,
            type: 2,
            page: 1,
            morename: "没有更多数据",
          });
        }
        //搜索定位
        this.$nextTick(function(){
          let that = this;
          let tMessage  = this.$el.querySelector("#message")
          tMessage.scrollTop = that.thatScrollHeight
          that.thatScrollHeight = tMessage.scrollHeight
        })
        this.textarea = "";
      });
    },

    //查看详情
    getContent(item) {
      //判断是否从畅捷通过来
      if (this.$store.state.cjt === true) {
        API_DATA.getDataCenter(item.id, this.questionId, this.key).then(
          (res) => {
            this.sbimtList.push({
              content: res.data.data[0],
              type: 3,
              typeid: 0,
            });
            this.$nextTick(function(){
              let that = this;
              let tMessage  = this.$el.querySelector("#message")
              tMessage.scrollTop = that.thatScrollHeight
              that.thatScrollHeight = tMessage.scrollHeight
            })
          }
        );
      } else {
        //必须登录才能看
        if (
          this.$store.state.userInfo.nickname == "" ||
          this.$store.state.userInfo.nickname == undefined ||
          this.$store.state.userInfo.nickname == null
        ) {
          this.$confirm("登录以后查看详细答案", "提示", {
            confirmButtonText: "登录",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$store.commit("userDetail", "");
              window.location.href =
                passportUrl +
                "?client_id=sbw&redirectUrl=" +
                window.location.href;
            })
            .catch(() => {});
        } else {
          API_DATA.getDataCenter(item.id, this.questionId, this.key).then(
            (res) => {
              //保存当前数据
              let thatData = res.data.data[0];
              //获取当前id数据是否收藏
              let data = {
                dataType:"sbw-all",
                projectCode:'sbw',
                aticleStrId:item.id,
              }
              let url = 'collections/isCollection'
              API_DATA.doPostData(data,url).then(res =>{
                //定义一个参数当前条数据是否被收藏
                let thatDataIsSC = res.data
                thatData.isCollection = thatDataIsSC;
                this.sbimtList.push({
                  content: thatData,
                  type: 3,
                  typeid: 0,
                });
                //搜索定位
                this.$nextTick(function(){
                  let that = this;
                  let tMessage  = this.$el.querySelector("#message")
                  tMessage.scrollTop = that.thatScrollHeight
                  that.thatScrollHeight = tMessage.scrollHeight
                  
                })
              })
              this.$nextTick(function(){
                let that = this;
                let tMessage  = this.$el.querySelector("#message")
                tMessage.scrollTop = that.thatScrollHeight
                that.thatScrollHeight = tMessage.scrollHeight
                
              })
            }
          );
          
        }
      }
    },
    //点击已解决为解决
    getTap(val, index) {
      this.sbimtList[index].typeid = val;
    },
    //收藏和取消收藏
    getSCHandle(status,tid,index){
      let url = '';
      let data = {
        projectCode: 'sbw',
        aticleStrId:tid,
        dataType:'sbw-all'
      }
      if(status==0){
        url = 'collections/save';
      }else if(status==1){
        url = 'collections/cancel';
      }
      API_DATA.doPostData(data,url).then(res =>{
        console.log(this.sbimtList)
        if(status==1){
          this.sbimtList[index].content.isCollection = 0
        }else{
          this.sbimtList[index].content.isCollection = 1
        }
      })
    }
  },
  //深度监听聊天内容是否改变 改变滚动
  watch: {
    sbimtList: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          let contant = this.$el.querySelector("#message");
          //contant.scrollTop = contant.scrollHeight;
        });
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
  overflow: hidden;
  width: 100%;
  margin-bottom: 20px;
  display: grid;
  grid-template-rows: 1fr auto;
}
.anwer-box {
  margin-top: 10px;
  // width: 930px;
  // height: 682px;
  max-height: calc(100vh - 391px);
  min-height: inherit;
  // min-height: calc(100vh - 391px);
  overflow-y: auto;
  background-color: #ffffff;
  box-shadow: 0px 2px 6px 0px rgba(194, 200, 211, 0.14);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 20px;
}
.time {
  margin: 0 auto;
  width: 60px;
  height: 24px;
  background-color: #e3e7ec;
  border-radius: 2px;
  line-height: 24px;
  text-align: center;
  color: #fff;
}
.img-left {
  width: 50px;
  height: 50px;
  float: left;
}
.dialogue-left {
  float: left;
  padding: 15px 20px;
  color: #222;
  background-color: #f0f5fa;
  font-size: 18px !important;
  margin-left: 20px;
  position: relative;
  border-radius: 8px;
  max-width: 550px;
  word-wrap: break-word;
}
.dialogue-left /deep/ p {
  margin-top: 2px;
  font-size: 18px !important;
}
.anchat-left {
  margin-top: 20px;
  overflow: hidden;
}
.dialogue-left::after {
  content: "";
  position: absolute;
  top: 17px;
  left: -20px;
  border-top: 8px solid #fff;
  border-bottom: 8px solid #fff;
  border-right: 10px solid #f0f5fa;
  border-left: 10px solid #fff;
}
.anchat-right {
  margin-top: 20px;
  overflow: hidden;
}
.img-right {
  width: 50px;
  height: 50px;
  float: right;
}
.dialogue-right {
  float: right;
  padding: 15px 20px;
  background-color: #2270e6;
  font-size: 18px;
  margin-right: 20px;
  position: relative;
  border-radius: 8px;
  max-width: 550px;
  word-wrap: break-word;
  color: #ffffff;
  margin-bottom: 20px;
}
.dialogue-right::after {
  content: "";
  position: absolute;
  top: 17px;
  right: -20px;
  border-top: 8px solid #fff;
  border-bottom: 8px solid #fff;
  border-right: 10px solid #fff;
  border-left: 10px solid #2270e6;
}
.send-content {
  padding: 20px;
  background-color: #fff;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  border-top: solid 1px #d7dadd;
  overflow: hidden;
}
.send-content /deep/.el-textarea__inner {
  border: 0px;
  padding: 0px;
}
.send-content /deep/.el-button {
  float: right;
  width: 80px;
  height: 35px;
  padding: 0px;
  line-height: 35px;
  margin-top: 10px;
  background-color: #2270e6;
  border-radius: 10px;
  color: #ffffff;
}

.dialogue-line {
  border-top: 1px solid #d7dadd;
  padding: 18px 0px 0px 0px;
  cursor: pointer;
}
.dialogue-line > p {
  color: #777777;
}
.serch-btn {
  width: 120px;
  height: 40px;
  background-color: #2270e6;
  border-radius: 10px;
  text-align: center;
  line-height: 40px;
  color: #fff;
  display: inline-block;
  margin-right: 80px;
  cursor: pointer;
}
.serch-btns {
  width: 120px;
  height: 40px;
  background-color: #ffffff;
  border-radius: 10px;
  border: solid 1px #d7dadd;
  text-align: center;
  line-height: 40px;
  color: #414141;
  display: inline-block;
  margin-right: 80px;
  cursor: pointer;
}
.anchat-search {
  width: 100%;
  overflow: hidden;
  text-align: center;
}
.text-font {
  color: #777;
}
.page-btn {
  text-align: right;
  color: #2270e6;
  cursor: pointer;
}
.unresolveds {
  background-color: #0d6d10;
  color: #fff;
  position: absolute;
  right: 28px;
  bottom: 15px;
  font-size: 18px;
  border-radius: 10px;
  padding: 0 10px;
  cursor: pointer;
}

.unresolved {
  background-color: #d33333;
  color: #fff;
  position: absolute;
  right: 160px;
  bottom: 15px;
  font-size: 18px;
  border-radius: 10px;
  padding: 0 10px;
  cursor: pointer;
}

.resolved {
  color: #d33333;
  position: absolute;
  right: 160px;
  bottom: 15px;
  font-size: 18px;
  border-radius: 10px;
  cursor: pointer;
}

.resolveds {
  color: #0d6d10;
  position: absolute;
  right: 40px;
  bottom: 15px;
  font-size: 18px;
  border-radius: 10px;
  cursor: pointer;
}
.resol-box {
  width: 100%;
  height: 35px;
}

// 定制版CSS
.aisino-box{
  overflow: hidden;
  width: 100%;
  // margin-bottom: 20px;
  display: grid;
  grid-template-rows: 1fr auto;
  border-right: solid 1px #dcdcdc;
}
.aisino-anwer-box{
  // margin-top: 10px;
  // width: 930px;
  // height: 682px;
  max-height: calc(100vh - 281px);
  min-height: calc(100vh - 281px);
  overflow-y: auto;
  background-color: #ffffff;
  // box-shadow: 0px 2px 6px 0px rgba(194, 200, 211, 0.14);
  // border-top-left-radius: 10px;
  // border-top-right-radius: 10px;
  padding: 20px;
}
.aisino-anchat-search{
  width: 100%;
  overflow: hidden;
  text-align: right;
  font-size: 14px;
}
.aisino-send-content {
  padding: 20px;
  background-color: #fff;
  // border-bottom-right-radius: 8px;
  // border-bottom-left-radius: 8px;
  border-top: solid 1px #d7dadd;
  overflow: hidden;
}
.aisino-send-content /deep/.el-textarea__inner {
  border: 0px;
  padding: 0px;
  font-size: 14px;
  color: #8b8b8b;
}
.aisino-send-content /deep/.el-button {
  float: right;
  width: 80px;
  height: 35px;
  padding: 0px;
  line-height: 35px;
  margin-top: 10px;
  background-color: #2270e6;
  border-radius: 10px;
  color: #ffffff;
}
.aisino-send-content /deep/.el-button.el-button.is-disabled {
  font-size: 16px;
  color: #414141;
}

// 通用覆盖
.el-button.is-disabled,
.el-button.is-disabled:focus,
.el-button.is-disabled:hover {
  color: #000000;
  cursor: not-allowed;
  background-image: none;
  background-color: #ebeef5;
  border-color: #ebeef5;
}
.el-button--primary {
  color: #fff;
  background-color: #2270e6;
  border-color: #2270e6;
}
.aisino-dialogue-left {
  float: left;
  padding: 15px 20px;
  color: #1e1e1e;
  background-color: #f0f5fa;
  font-size: 16px !important;
  margin-left: 20px;
  position: relative;
  border-radius: 8px;
  max-width: 550px;
  word-wrap: break-word;
}
.aisino-dialogue-left /deep/ p {
  margin-top: 2px;
  font-size: 18px !important;
}
.aisino-dialogue-right {
  float: right;
  padding: 15px 20px;
  background-color: #2270e6;
  font-size: 16px;
  margin-right: 20px;
  position: relative;
  border-radius: 8px;
  max-width: 550px;
  word-wrap: break-word;
  color: #ffffff;
  margin-bottom: 20px;
}
/**收藏*/
.shoucangBox{
  width:100%;
  height:40px;
  line-height: 40px;
  font-size:16px;
  color:#777777;
  margin-top:10px;
  /*position:absolute;*/
  /*bottom:15px;*/
  /*left: 20px;*/
  cursor: pointer;
} 
.shoucangBoxRight{
  width:76px;
  float: right;
}
.shoucangBox img{
  width: 16px;
  height: 16px;
  margin-right:8px;
}
.newDayi{
  color:#2770e6;
}
</style>
